<template>
    <div class="as-content-login">
        <v-card class="as-login-container">
            <v-img :src="image_path" class="my-2" />
            <v-form @submit.prevent="login">
                <v-text-field v-model="email" :readonly="loading" class="mb-2" clearable label="Usuario"
                    placeholder="Escriba su usuario..." color="blue-darken-3"></v-text-field>

                <v-text-field v-model="password" :readonly="loading"  label="Contraseña"
                    placeholder="Escriba su contraseña..." color="blue-darken-3"
                    :append-inner-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'"
                    autocomplete="off" @click:append-inner="show = !show"></v-text-field>

                <v-btn :loading="loading" block color="blue-darken-3" size="large" type="submit" variant="elevated">
                    Ingresar
                </v-btn>
            </v-form>
        </v-card>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/stores/useAuth';
import useToastify from '@/composables/useToastify';
//data
const image_path = require('@/assets/images/logo.png')
const email = ref("");
const password = ref("");
const loading = ref(false);
const router = useRouter();
const show = ref(false);

const auth = new useAuth();
const snackbar = ref(false);
const login = async () => {
    loading.value = true;
    setTimeout(async () => {
        const respuesta = await auth.login(email.value, password.value);
        loading.value = false;
        if (respuesta) {
            router.push("/home");
        } else {
            snackbar.value = true;
        }
    }, 500);
}
</script>

<style scoped>
.as-content-login {
    display: flex;
    justify-content: flex-end; /* Alinea el contenedor a la derecha */
    align-items: center; /* Centra verticalmente */
    min-height: 100vh;
    padding-right: 50px;
    background-image: linear-gradient(to bottom, rgb(204, 204, 204, 0.5), rgb(153, 153, 153, 0.5)), url(@/assets/images/background.jpg);
    background-size: cover;
    overflow: hidden !important;
}

.as-login-container {
    background-color: rgba(255, 255, 255, 0.699);
    width: 400px; /* Ancho del cuadro de login */
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.2);
}

/* Media queries para hacer el diseño responsive */
@media screen and (max-width: 768px) {
    .as-content-login {
        justify-content: center; /* Centra el contenedor horizontalmente */
    }
    .as-login-container {
        width: 90%; /* Reduzca el ancho del cuadro de login */
    }
}
</style>
